import React from 'react';
import { FiBox } from 'react-icons/fi';

const FunctionIcon: React.FC = () => {
  return <FiBox />;
};

export default FunctionIcon;
